const initialState = {
    bool: false
}

const crewAgenciesInputErrRed = (state = initialState, action) => {
    switch(action.type){
        case 'CREW_AGENCIES_INPUT_ERR' : {
            return {
                ...state,
                bool: action.bool
            }
        }
        default: {
            return state
        }
    }
}

export default crewAgenciesInputErrRed